import { I18n } from '@app/i18n/strings-keys';

const CHARGEABLE_LABEL = {
  chargeable: I18n.Forms.GridForm.ChargeableOnly,
  allItems: I18n.Forms.GridForm.AllItems,
};

const HIDE_COLUMNS_FIELDS_WHEN_OFF_POST_CLOSURE = [
  'sale_post_closure',
  'price_post_closure',
  'tax_post_closure',
  'discount_post_closure',
  'post_closure_sales',
  'total_tax_post_closure',
  'custom_post_closure',
  'tips_post_closure',
  'cash_post_closure',
  'post_closure_dollars_discounted',
  'credit_debit_gift_post_closure_total',
];

const STAND_WORKSHEET_PDF_SELECTED_COLUMNS =
  'stand-worksheet-pdf-selected-columns';

const STAND_WORKSHEET_PDF_SELECTED_UP_COLUMNS = 18;

export {
  CHARGEABLE_LABEL,
  HIDE_COLUMNS_FIELDS_WHEN_OFF_POST_CLOSURE,
  STAND_WORKSHEET_PDF_SELECTED_COLUMNS,
  STAND_WORKSHEET_PDF_SELECTED_UP_COLUMNS,
};
